import React, { Fragment, useState } from 'react';
import {Link} from "react-router-dom";
import logoMain from "../../images/mainLogo.png"
import consultPng from "../../images/konsultacija.png"
import aboutPng from "../../images/apie.png"
import careerPng from "../../images/karjera.png"
import dashesPng from "../../images/bruksniai2.png"
import recommendPng from "../../images/Recomend.png"


import Popup from'./Popup.js';

import Media from 'react-media';

export default function Navbar(){
  const[buttonPopup, setButtonPopup] = useState(false);
    return(
        <div className="navbar">
        <Media queries={{
          small: "(max-width: 799px)",
          large: "(min-width: 800px)"
        }}>
          {matches => (
            <Fragment>
              {matches.small && 
                <nav className="nav1">        
                    <Link to="/" className="logo"><img className="navbarImages" src={logoMain} alt="example"></img></Link>                
                    <button className="dashes" onClick={() => setButtonPopup(true) }><img className="dashes" src={dashesPng} alt="example"></img></button>
                    <Popup trigger={buttonPopup} setTrigger={setButtonPopup}>
                    <nav className="nav1mobile">
                    <Link to="/" onClick={() => setButtonPopup(false) } className="mobile"><img className="navbarImages" src={logoMain} alt="example"></img></Link><br />
                    <Link to="/konsultacija" onClick={() => setButtonPopup(false) } className="mobile mobileNavbarBtn">Konsultacija</Link><br />
                    <Link to="/karjera" onClick={() => setButtonPopup(false) } className="mobile mobileNavbarBtn">Karjera</Link><br />
                    <Link to="/atsiliepimai" onClick={() => setButtonPopup(false) } className="mobile mobileNavbarBtn">Atsiliepimai</Link><br />
                    <Link to="/apie" onClick={() => setButtonPopup(false) } className="mobile mobileNavbarBtn">Apie</Link>
                    </nav>
                    </Popup>
                </nav>}

              {matches.large &&
                    <nav className="nav1">        
                    <Link to="/" className="logo"><img className="navbarImages" src={logoMain} alt="example"></img></Link>
                    <Link to="/konsultacija" className="marginBtnNavbar"><img className="navbarImages" src={consultPng} alt="example"></img></Link>
                    <Link to="/karjera" className="btn"><img className="navbarImages" src={careerPng} alt="example"></img></Link>
                    <Link to="/atsiliepimai" className="btn"><img className="navbarImages" src={recommendPng} alt="example"></img></Link>
                    <Link to="/apie" className="btn"><img className="navbarImages" src={aboutPng} alt="example"></img></Link>
                    </nav>}
            </Fragment>
          )}
        </Media>
        
        </div>
    )
}